import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=7ef4630e&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=7ef4630e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4630e",
  null
  
)

export default component.exports